import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-psa-clients',
  templateUrl: './psa-clients.component.html',
  styleUrls: ['./psa-clients.component.css']
})
export class PsaClientsComponent implements OnInit {
  title="Clients Details";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/psadetails/psa-list/psa-clients/psa-clients.component.ts